<button mat-icon-button [matMenuTriggerFor]="userActions">
    <span class="relative">
        <!--<mat-icon [svgIcon]="'heroicons_outline:user-circle'"></mat-icon>
    <span class="absolute right-0 bottom-0 w-2 h-2 rounded-full"
          [ngClass]="{'mr-px mb-px': true,
                      'bg-green-500': user?.status === 'online',
                      'bg-amber-500': user?.status === 'away',
                      'bg-red-500': user?.status === 'busy',
                      'bg-gray-400': user?.status === 'not-visible'}"></span>-->
        @if (showAvatar && user?._profileImage) {
        <img class="w-7 h-7 rounded-full" [src]="user?._profileImage">
        }
        @if (!showAvatar || !user?._profileImage) {
        <mat-icon class="icon-size-7" [svgIcon]="'heroicons_outline:user-circle'"></mat-icon>
        }
        @if (!isHideStatusUserProfile) {
        <span class="absolute right-0 bottom-0 w-3 h-3 rounded-full -mr-px -mb-px" style="border: 1px solid white;" [style.background-color]="user?.personStatusColour ?? 'transparent'"></span>
        }
    </span>
</button>

<mat-menu [xPosition]="'before'" #userActions="matMenu">
    <button mat-menu-item style="pointer-events: none">
        <span class="flex flex-col leading-none py-2">
            <span class="text-sm text-gray-800">Signed in as</span>
            <span class="mt-2 text-lg font-medium capitalize">{{user?.displayName}}</span>
            <span class="mt-2 text-sm font-extralight">{{user?.emailAddress}}</span>
        </span>
    </button>
    <mat-divider class="my-2"></mat-divider>
    <button mat-menu-item (click)="signOut()">
        <mat-icon [svgIcon]="'heroicons_outline:arrow-right-on-rectangle'"></mat-icon>
        <span>Sign Out</span>
    </button>
    <!--     <mat-divider class="my-2"></mat-divider>
        <button mat-menu-item>
            <mat-icon [svgIcon]="'heroicons_outline:user-circle'"></mat-icon>
            <span>Profile</span>
        </button>
        <button mat-menu-item>
            <mat-icon [svgIcon]="'heroicons_outline:cog-8-tooth'"></mat-icon>
            <span>Settings</span>
        </button>
        <button
            mat-menu-item
            [matMenuTriggerFor]="userStatus">
            <mat-icon [svgIcon]="'heroicons_outline:ellipsis-horizontal-circle'"></mat-icon>
            <span>Status</span>
        </button> -->
    <!--<mat-divider class="my-2"></mat-divider>
    <button mat-menu-item
            (click)="signOut()">
        <mat-icon [svgIcon]="'heroicons_outline:arrow-right-on-rectangle'"></mat-icon>
        <span>Sign out</span>
    </button>-->
</mat-menu>
<!--
<mat-menu
    class="user-status-menu"
    #userStatus="matMenu">
    <button
        mat-menu-item
        (click)="updateUserStatus('online')">
        <span class="w-4 h-4 mr-3 rounded-full bg-green-500"></span>
        <span>Online</span>
    </button>
    <button
        mat-menu-item
        (click)="updateUserStatus('away')">
        <span class="w-4 h-4 mr-3 rounded-full bg-amber-500"></span>
        <span>Away</span>
    </button>
    <button
        mat-menu-item
        (click)="updateUserStatus('busy')">
        <span class="w-4 h-4 mr-3 rounded-full bg-red-500"></span>
        <span>Busy</span>
    </button>
    <button
        mat-menu-item
        (click)="updateUserStatus('not-visible')">
        <span class="w-4 h-4 mr-3 rounded-full bg-gray-400"></span>
        <span>Invisible</span>
    </button>
</mat-menu>
 -->
